module.exports = __webpack_public_path__ + "img/yqh3.c45376ea.jpg";